/**
 * @license
 * @copyright Copyright Motili Inc., 2020 All Rights Reserved
 */

import ApiService from 'common/services/ApiService';

export function calculateProgress(sections) {
    let totalNumberOfItems = 0;
    let itemsComplete = 0;
    sections.forEach(section => {
        section.items.forEach(item => {
            totalNumberOfItems += 1;
            if (item.complete || item.notApplicable) {
                itemsComplete += 1;
            }
        });
    });
    return Math.round((itemsComplete / totalNumberOfItems) * 100);
}

export async function downloadChecklist(checklist) {
    return ApiService.post(
        true,
        `workOrders/${checklist.workOrderId}/requirements/${checklist.id}/export`
    );
}

export async function downloadChecklists(checklists) {
    return Promise.all(
        checklists.map(c =>
            ApiService.post(
                true,
                `workOrders/${c.workOrderId}/requirements/${c.id}/export`
            )
        )
    );
}
